<div class="input-container">
  <oph-icon [name]="'list-views/search'" [size]="22"></oph-icon>
  <input
    [placeholder]="placeholder || 'Search'"
    [formControl]="control"
    [ngStyle]="inputStyle"
    (input)="valueChange.emit(control.value)"
  />
</div>
